import { useEffect, useRef, useState } from "react";

/**
 * Hook to ensure a minimum delay for loading states
 *
 * @param loading - The current loading state
 * @param minMs - The minimum duration (in milliseconds) to show the loading state
 * @returns A boolean indicating whether to show the loading state
 */

const useMinimumDelay = (loading: boolean, minMs: number = 500): boolean => {
  const [showLoading, setShowLoading] = useState(false);
  const startTimeRef = useRef<number | null>(null);

  useEffect(() => {
    if (loading) {
      startTimeRef.current = Date.now();
      setShowLoading(true);
    } else if (startTimeRef.current) {
      const elapsed = Date.now() - startTimeRef.current;
      const remaining = Math.max(0, minMs - elapsed);

      const timer = setTimeout(() => {
        setShowLoading(false);
        startTimeRef.current = null;
      }, remaining);

      return () => clearTimeout(timer);
    }
  }, [loading, minMs]);

  return showLoading;
};

export { useMinimumDelay };
